<template>
  <crm-settings />
</template>

<script>
import CrmSettings from "@/components/3pl/CRM/CustomerRegistration/Home";
export default {
  components: {
    CrmSettings,
  },
};
</script>

<style></style>
